import { Link } from "react-router-dom";
import { Sparkles } from "lucide-react";
import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";

/**
 * Il permesso per l'intelligenza artificiale di terzi, chiesto una volta sola
 * sull'iPhone prima del primo uso dell'assistente (Apple 5.1.2(i), 04/10/2026).
 * Dice chi riceve i dati (OpenAI) e cosa, e lascia la scelta: senza permesso
 * l'assistente resta spento, gli strumenti di calcolo no.
 */
export function ConsensoAI({
  aperto,
  onAccetta,
  onRifiuta,
}: {
  aperto: boolean;
  onAccetta: () => void;
  onRifiuta: () => void;
}) {
  return (
    <Dialog open={aperto} onOpenChange={(o) => { if (!o) onRifiuta(); }}>
      <DialogContent className="max-h-[calc(100dvh-2rem)] max-w-md overflow-y-auto">
        <DialogHeader>
          <div className="mx-auto mb-2 flex h-12 w-12 items-center justify-center rounded-full bg-primary/15">
            <Sparkles className="h-6 w-6 text-primary" aria-hidden="true" />
          </div>
          <DialogTitle className="text-center">Prima di usare l&apos;assistente</DialogTitle>
          <DialogDescription className="text-center">
            Le domande che scrivi, le foto che alleghi e i messaggi vocali vengono inviati a{" "}
            <strong className="text-foreground">OpenAI</strong> (Stati Uniti), che li elabora per
            generare le risposte e trascrivere la voce. Non li usa per addestrare i suoi modelli.
          </DialogDescription>
        </DialogHeader>
        <p className="text-center text-sm text-muted-foreground">
          I dettagli sono nella{" "}
          <Link to="/privacy" className="text-primary underline underline-offset-2">
            privacy
          </Link>
          . Puoi usare gli strumenti di calcolo anche senza dare il permesso.
        </p>
        <DialogFooter className="flex-col gap-2 sm:flex-col">
          <Button className="min-h-11 w-full" onClick={onAccetta}>
            Accetto
          </Button>
          <Button variant="outline" className="min-h-11 w-full" onClick={onRifiuta}>
            Non ora
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
